import { httpsCallable } from "firebase/functions";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db, functions } from "../lib/firebase";

export type BroadcastSourceType = "special" | "notice" | "daily_menu";

export interface BroadcastPreview {
  content: {
    kitchenId: string | null;
    kitchenName: string;
    title: string;
    dishLines: string;
    price: string;
    cutoff: string;
    linkPath: string;
    imageUrl: string | null;
    isActive: boolean;
  };
  templatePreview: string;
  channelText: string;
  templateName: string;
  templates: Record<string, { status: string; rejected_reason?: string }>;
  recipientCount: number;
  stats: {
    totalUsers: number;
    uniquePhones: number;
    optedIn: number;
    activeSubscribers: number;
    optedOut: number;
    notConsented: number;
    eligible: number;
    excludedBusinessNumber: number;
    noPhone: number;
  };
  recipientsSample: { phone: string; name: string; reason: string }[];
  config: { enabled: boolean; autoSend: boolean; maxRecipients: number; perUserDailyCap: number; allowKitchenManagers: boolean };
  record: null | {
    status: string | null;
    sentAt: number | null;
    recipientsCount: number | null;
    sentCount: number | null;
    failedCount: number | null;
    skippedCapped: number | null;
    deliveredCount?: number | null;
    deliveryFailedCount?: number | null;
    deliveryFailuresByCode?: Record<string, number> | null;
    readCount?: number | null;
    lastTest: null | { at: number | null; to: string; ok: boolean; via: string; error?: any; deliveryStatus?: string | null; errorCode?: number | null; errorTitle?: string | null };
  };
  canLiveSend: boolean;
  liveBlockers: string[];
  myPhone: string | null;
}

export const getBroadcastPreview = async (sourceType: BroadcastSourceType, sourceId: string) => {
  const fn = httpsCallable(functions, "whatsappBroadcastPreview");
  const r = await fn({ sourceType, sourceId });
  return r.data as BroadcastPreview;
};

export const sendBroadcast = async (
  sourceType: BroadcastSourceType,
  sourceId: string,
  mode: "test" | "live"
) => {
  const fn = httpsCallable(functions, "whatsappBroadcastSend", { timeout: 540000 });
  const r = await fn({ sourceType, sourceId, mode });
  return r.data as any;
};

export const setMyWhatsAppOptIn = async (optIn: boolean) => {
  const fn = httpsCallable(functions, "setWhatsAppOptIn");
  const r = await fn({ optIn });
  return r.data as { ok: boolean; whatsappOptIn: boolean };
};

export interface BroadcastSettings {
  enabled: boolean;
  autoSend: boolean;
}

export const getBroadcastSettings = async (): Promise<BroadcastSettings> => {
  const s = await getDoc(doc(db, "settings", "whatsappBroadcast"));
  const d = s.exists() ? (s.data() as any) : {};
  return { enabled: d.enabled === true, autoSend: d.autoSend === true };
};

export const updateBroadcastSettings = async (patch: Partial<BroadcastSettings>, by: string) => {
  await setDoc(
    doc(db, "settings", "whatsappBroadcast"),
    { ...patch, updatedAt: serverTimestamp(), updatedBy: by },
    { merge: true }
  );
};
